/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSkillsContent } from "../../funcs/llmSkillsContent.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetSkillContentRequest$inboundSchema,
};

export const tool$llmSkillsContent: ToolDefinition<typeof args> = {
  name: "llm-skills-content",
  description: `Download skill content

Download the zip bundle for a skill's default version.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSkillsContent(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
